import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { DistributorFilter } from '../../models/distributor-filter';
import { HttpClient } from '@angular/common/http';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { DistributorAuction } from '../../models/distributor-auction';

const apiServer = environment.apiServer;
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-home-main-modal-detail-member',
  templateUrl: './home-main-modal-detail-member.component.html',
  styleUrls: ['./home-main-modal-detail-member.component.sass']
})
export class HomeMainModalDetailMemberComponent implements OnInit, AfterViewInit {

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  dt: DataTables.Api;
  modelDistributorFilter: DistributorFilter = new DistributorFilter();
  modelDistributorAuction: DistributorAuction = new DistributorAuction();
  dtOptionsDistributors: DataTables.Settings = {};
  dataSetDistributors: any;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService) { }

  ngOnInit() {

    const that = this;
    this.dtOptionsDistributors = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.search = this.modelDistributorFilter.name;

        dataTablesParameters.IDAuc = this.bus.currentAuction.code;

        that.http.post<DataTablesResponse>(`${apiServer}/distributor`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetDistributors = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { orderable: false },
        { data: 'distributorName', name: 'distrName' },
      ]
    };

  }

  onFieldChange() {
    this.dt.ajax.reload();
  }

  onSelectDistributer(selectedType: string, distributor: string, distributorId: string): void {
    this.modelDistributorAuction = new DistributorAuction();

    switch (this.bus.currentDistributorType.type) {
      case 1:
        {
          this.modelDistributorAuction.distributerParticipant = distributorId;
          this.modelDistributorAuction.distributerParticipantName = distributor;
          $('#modalDetailDistributorMember').modal('hide');
          break;
        }
      case 2:
        {
          this.modelDistributorAuction.distributerParticipant2 = distributorId;
          this.modelDistributorAuction.distributerParticipant2Name = distributor;
          $('#modalDetailDistributorMember').modal('hide');
          break;
        }
      case 4:
        {
          this.modelDistributorAuction.distributerWinner = distributorId;
          this.modelDistributorAuction.distributerWinnerName = distributor;
          $('#modalDetailDistributorWinner').modal('hide');
          break;
        }
      case 5:
        {
          this.modelDistributorAuction.distributerLogistic = distributorId;
          $('#modalDetailDistributorLogist').modal('hide');
          break;
        }
    }
    this.bus.changeDistributerAuction(this.modelDistributorAuction);
  }

  onSelectDistributerRow(selectedType: string, distributor: string, distributorId: string): void {
    this.modelDistributorAuction = new DistributorAuction();

    switch (this.bus.currentDistributorType.type) {
      case 1:
        {
          this.modelDistributorAuction.distributerParticipant = distributorId;
          this.modelDistributorAuction.distributerParticipantName = distributor;
          $('#modalDetailDistributorMember').modal('hide');
          break;
        }
      case 2:
        {
          this.modelDistributorAuction.distributerParticipant2 = distributorId;
          this.modelDistributorAuction.distributerParticipant2Name = distributor;
          $('#modalDetailDistributorMember').modal('hide');
          break;
        }
      case 4:
        {
          this.modelDistributorAuction.distributerWinner = distributorId;
          this.modelDistributorAuction.distributerWinnerName = distributor;
          $('#modalDetailDistributorWinner').modal('hide');
          break;
        }
      case 5:
        {
          this.modelDistributorAuction.distributerLogistic = distributorId;
          $('#modalDetailDistributorLogist').modal('hide');
          break;
        }
    }
    this.bus.changeDistributerAuction(this.modelDistributorAuction);
  }



  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail-member/home-main-modal-detail-member.component.ts